import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';
import { getLoginLocale } from './keycloak.providers';
import { KeycloakInitStatusService } from './services/keycloak-init-status.service';
import { getCurrentLanguagePath } from './utils';

export const authGuard = createAuthGuard<CanActivateFn>(async (_route, state, { authenticated, keycloak }) => {
    if (inject(KeycloakInitStatusService).failed()) {
        return false;
    }
    if (authenticated) {
        return true;
    }
    void keycloak.login({ redirectUri: window.location.origin + getCurrentLanguagePath() + state.url, locale: getLoginLocale() });
    return false;
});
